import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import MarkDown from '../components/MarkDown';
import Footer from '../components/Footer';
import SienBanner from '../components/SienBanner';
import { AdIcons } from '../components/Ad';
import '../blog.css';
import {
  DEFAULT_IMAGE,
  extractMarkdownMetadata,
  fetchStaticMarkdown,
} from '../utils/markdownContent';

function Sermon() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState('');
  const { id } = useParams();

  useEffect(() => {
    let isMounted = true;

    const fetchMetadata = async () => {
      try {
        const text = await fetchStaticMarkdown(`/sermon/${id}`);
        if (!isMounted) {
          return;
        }
        const metadata = extractMarkdownMetadata(text, {
          description: '説教の内容をお読みください。',
        });
        const resolvedTitle = metadata.title
          ? `${metadata.title} - 説教 - ASMRキリスト教会`
          : '説教 - ASMRキリスト教会';
        setTitle(resolvedTitle);
        setDescription(metadata.description || '説教の内容をお読みください。');
        setImage(metadata.image || DEFAULT_IMAGE);
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setTitle('説教 - ASMRキリスト教会');
          setDescription('ASMRキリスト教会の説教');
          setImage(DEFAULT_IMAGE);
        }
      }
    };

    fetchMetadata();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const url = `https://www.asmrchurch.com/sermon/${id}`;

  return (
    <div>
      <div className="bibleframe">
      <Header
        title={title || '説教 - ASMRキリスト教会'}
        description={description}
        url={url}
        image={image}
      />

      <div className="flex-container">
        <div className="left-area" style={{ width: '26%' }}>
          <AdIcons />
        </div>

      <div className="content">
        <MarkDown
          articleType="sermon"
          articleId={id}
          fallbackPath={`/sermon/${id}`}
        />
        <div className="return">
          <a href="/sermon">説教一覧</a>
        </div>
        <div className="mobile-ads">
          <AdIcons />
        </div>
      </div>

      <div className="right-area">
        <SienBanner />
        <span className="pad">
          {/*
          <stripe-buy-button
            buy-button-id="buy_btn_1QiEyXJrEFc0aoshZrg6uGA0"
            publishable-key="pk_live_51L77y9JrEFc0aoshDbT8faRDJBWQJjQTGvMb8e0be0ZsfG2yEWaxYdMSlGSS9pgX00RNzmWvfw"
          >
          </stripe-buy-button>
          */}
        </span>
      </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}

export default Sermon;
